var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Injectable } from '@angular/core';
import { Size } from './size';
var SizeService = /** @class */ (function () {
    function SizeService() {
        this.separator = ' ';
    }
    SizeService.prototype.parse = function (sizeString, separator) {
        if (separator === void 0) { separator = this.separator; }
        if (sizeString) {
            var stringArray = sizeString.split(separator);
            if (stringArray.length === 2) {
                return new Size(+stringArray[0], +stringArray[1]);
            }
        }
        return undefined;
    };
    SizeService.prototype.isValidSizeStr = function (sizeString, separator) {
        if (separator === void 0) { separator = this.separator; }
        if (sizeString) {
            var size = this.parse(sizeString, separator);
            if (!size) {
                return false;
            }
            return size.isReal().valueOf();
        }
        return false;
    };
    SizeService = __decorate([
        Injectable()
    ], SizeService);
    return SizeService;
}());
export { SizeService };
